export default "__VITE_ASSET__D$YLxTJ___"